import {
  TimelineContainer,
  TimelineLine,
  TimelineDateGroup,
  TimelineDate,
  ContractsList,
  ContractItem,
  ContractType,
  ContractPrestationType,
  CustomToggleIcon, HeaderContainer, StyledContainer, IconWrapper, StyledTitle
} from './styled-components'
import useTabBar from '@/containers/SubscriptionFormPageNew/SubscriptionForm/useTabBar'
import { useState } from 'react'
import IconBolt from '@/shared/icons/NewDesign/IconBolt'
import IconUser from '@/shared/icons/NewDesign/IconUser'
import IconPhone from '@/shared/icons/NewDesign/IconPhone'
import IconShieldPerson from '@/shared/icons/NewDesign/IconShieldPerson'
import { useSelector } from 'react-redux'
import {
  selectAdditionalClientSubscriptionData
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import HistoricSalesEmpty from '@/containers/SubscriptionFormPageNew/Components/HistoricSales/HistoricSalesEmpty'

const HistoricSales = () => {
  const {
    pushToOpenedContracts,
    groupedContractsByDate,
    t,
  } = useTabBar()

  const [expanded, setExpanded] = useState(true)
  const toggleExpanded = () => setExpanded(prev => !prev)

  const getTypeIcon = (type) => {
    switch (type) {
      case 'energy':
        return <IconBolt size={20} style={{ verticalAlign: 'middle' }} />
      case 'insurance':
        return <IconShieldPerson size={20} style={{ verticalAlign: 'middle' }} />
      case 'telecom':
        return <IconPhone size={19} style={{ verticalAlign: 'middle' }} />
      default:
        return null
    }
  }

  const additionalClient = useSelector(selectAdditionalClientSubscriptionData)

  const clientCreationItem =
    additionalClient && additionalClient.createdAt
      ? {
        date: additionalClient.createdAt.split(' ')[0],
        isClientCreation: true,
        contracts: []
      }
      : null

  if (groupedContractsByDate.length === 0) {
    return <HistoricSalesEmpty t={t} />
  }

  const timelineItems = clientCreationItem
    ? [clientCreationItem, ...groupedContractsByDate]
    : groupedContractsByDate

  return (
    <StyledContainer>
      <HeaderContainer>
        <StyledTitle>{t('subscriptionTools:historic_contracts.module_title')}</StyledTitle>
        <div onClick={toggleExpanded} style={{ cursor: 'pointer' }}>
          <CustomToggleIcon $expanded={expanded} />
        </div>
      </HeaderContainer>
      {expanded && (
      <TimelineContainer>
        {timelineItems.map(({ date, contracts, isClientCreation }, index) => (
          <div key={date}>
            {index === 0 && (
              <TimelineLine
                $last={index === groupedContractsByDate.length - 1}
                $itemsCount={contracts.length}
              />
            )}
            <TimelineDateGroup>
              <TimelineDate>{date}</TimelineDate>
              <ContractsList>
                {isClientCreation ? (
                  <ContractItem>
                    <ContractType>
                      <IconWrapper>
                        <IconUser size={19} />
                      </IconWrapper>
                      <span>{t('subscriptionTools:historic_contracts.client_creation')}</span>
                    </ContractType>
                  </ContractItem>
                ) : (
                  contracts.map(contract => (
                    <ContractItem key={contract.id} onClick={() => pushToOpenedContracts(contract)}>
                      <ContractType>
                        <IconWrapper>{getTypeIcon(contract.type)}</IconWrapper>
                        <span>
                            {t(`common:${contract.type}_sale`)} ({contract.characteristics.providerName})
                          </span>
                      </ContractType>
                      <ContractPrestationType>
                        {contract.characteristics.prestationType}
                      </ContractPrestationType>
                    </ContractItem>
                  ))
                )}
              </ContractsList>
            </TimelineDateGroup>
          </div>
        ))}
      </TimelineContainer>
      )}
      </StyledContainer>
  )
}

export default HistoricSales
